import { functions } from '@/firebase';
import {
  CreateSpeechRequest,
  GetPaymentUrlRequest,
  GetPaymentUrlResponse,
  GetSpeechRequest,
  GetSpeechResponse,
} from '@packages/types';
import { httpsCallable } from 'firebase/functions';

export const createSpeech = httpsCallable<CreateSpeechRequest, { id: string }>(
  functions,
  'createSpeech',
);

export const getSpeech = httpsCallable<GetSpeechRequest, GetSpeechResponse>(functions, 'getSpeech');
export const getPaymentUrl = httpsCallable<GetPaymentUrlRequest, GetPaymentUrlResponse>(
  functions,
  'getPaymentUrl',
);
